// extracted by mini-css-extract-plugin
export default {"submit":"submit--clQWD"};